import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { dataTestIds } from '../../../../constants/data-test-ids';
import { Loader } from '../../shared/components/Loader';
import { PageTitle } from '../../shared/components/PageTitle';
import { useChartData } from '../../shared/hooks/useChartData';
import { useAppointmentData } from '../../shared/stores/appointment/appointment.store';
import { MedicalConditionsBody } from '../components/medical-conditions/MedicalConditionsBody';
import { useInPersonNavigationContext } from '../context/InPersonNavigationContext';
interface MedicalConditionsProps {
  appointmentID?: string;
}

export const MedicalConditions: FC<MedicalConditionsProps> = () => {
  const {
    resources: { appointment },
    isAppointmentLoading,
    appointmentError,
  } = useAppointmentData();

  const { isChartDataLoading, chartDataError } = useChartData();
  const isLoading = isAppointmentLoading || isChartDataLoading;
  const error = chartDataError || appointmentError;
  const { interactionMode } = useInPersonNavigationContext();

  if (isLoading) return <Loader />;
  if (error?.message) return <Typography>Error: {error.message}</Typography>;
  if (!appointment) return <Typography>No data available</Typography>;

  return (
    <Stack spacing={1}>
      <PageTitle
        dataTestId={dataTestIds.medicalConditions.medicalConditionsPageTitle}
        label="Medical Conditions"
        showIntakeNotesButton={interactionMode === 'main'}
      />
      <MedicalConditionsBody />
    </Stack>
  );
};
